// @flow
import React, { PureComponent } from "react"
import classnames from "classnames"
import type { Node } from "react"

const ICONS_CLASSNAMES = {
  error: "ic_error_outline",
  warning: "ic_warning",
  ok: "ic_ok_outline",
  info: "ic_info_outline",
  "info-new": "ic_info_outline",
}

type Props = {
  bordered: boolean,
  light: boolean,
  type: "error" | "warning" | "ok" | "info" | "info-new",
  className: string,
  closable: boolean,
  children: Node,
  iconClassName?: string,
  onClose?: () => void,
  transparent: boolean,
  reducedSpace?: boolean,
  noIcon: boolean,
  dataTest?: string,
}

type State = {
  visible: boolean,
}

export default class Alert extends PureComponent<Props, State> {
  static defaultProps = {
    bordered: false,
    closable: true,
    transparent: false,
    light: false,
    type: "ok",
    noIcon: false,
    className: "",
  }

  state: State = {
    visible: true,
  }

  onClose = () => {
    const { onClose } = this.props

    if (onClose) {
      onClose()
    }

    this.setState({
      visible: false,
    })
  }

  render() {
    const {
      bordered,
      children,
      closable,
      iconClassName,
      transparent,
      type,
      light,
      reducedSpace,
      className,
      noIcon,
      dataTest,
    } = this.props

    const { visible } = this.state

    const _iconClassName = iconClassName || ICONS_CLASSNAMES[type]

    return (
      <div
        className={classnames(`Alert _${type} ${className}`, {
          _transparent: transparent,
          _bordered: bordered,
          _light: light,
          _closed: !visible,
          _reducedSpace: reducedSpace,
        })}
        data-test={dataTest}
      >
        {closable && (
          <i className="Alert-type-icon Alert-close-btn md-close" onClick={this.onClose} />
        )}
        <div className="Alert-content">
          {!noIcon && (
            <i className={`Alert-type-icon spIcon ${_iconClassName}`} aria-hidden="true" />
          )}
          <div className="Alert-message">{children}</div>
        </div>
      </div>
    )
  }
}
